import { defineStore } from 'pinia';

export const useCommonSettingsStore = defineStore('commonSettings', {
  state: () => ({
    showQuickStartup: false,
    tvmHelpModalSettings: {},
    tvmNavigateTileSettings: {},

    tvmOldTid: '',
    vehicleDetails: {},
    mobileNavigationDetails: [],
    getSubaruOemCodes: '',
    menuSectionSettings: [],
  }),
});
